import { AppHeaderBackButton, Box, CircularProgress, Typography } from '@ace-clublabs/shared-component-library';
import { useNavigate } from 'react-router-dom';
import { AutoPayForm } from '../components/AutoPayForm';
import { Pages } from '../shared/pages';
import { useGlobalState } from '../shared/state';
import { useEffect, useState } from 'react';
import { UtagHelper } from '../utils/utagHelper';
import { loginOnClick } from '../utils/methods';
import { AppFlow } from '@lib/web-shared';
import { ErrorType, IInitializePaymentRequest } from '../shared/types';
import { sources } from '../api/sources';
import Spinner from '../components/Spinner';

export const AutoPayPage: React.FC = () => {
  const navigate = useNavigate();
  const onClickBack = () => navigate(-1);
  const [, setAutoPayEnroll] = useGlobalState('selectedAutoPay');
  const [policyPaymentInfo] = useGlobalState('policyPaymentInfo');
  const [clubCode] = useGlobalState('clubCode');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [alreadyPaidOption] = useGlobalState('alreadyPaidOption');
  const [amountChosen] = useGlobalState('amountChosen');
  const [clubTag] = useGlobalState('clubTag');
  const [policyMetaData] = useGlobalState('policyMetaData');
  const { minimumDue, fullBalance, allowAutoPay, autoPayFeatureIsOffline } = policyPaymentInfo || {};
  const [appFlow] = useGlobalState('appFlow');
  const [policyNumber] = useGlobalState('policyNumber');
  const [brokerRegion] = useGlobalState('brokerRegion');
  const [tagging, setIsTagging] = useState(true);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    const ins_min_due = minimumDue ? 'true' : 'false';
    const ins_autopaycampaign = allowAutoPay ? 'autopay required' : 'autopay not required';
    const ins_policy = policyMetaData.prefix;
    const tags = { ...UtagHelper.loadCommonTags(appFlow), page: UtagHelper.getPages(appFlow).autoPayPage };
    UtagHelper.tag({
      ...tags,
      club: clubTag,
      ins_min_due,
      ins_autopaycampaign: appFlow === AppFlow.AUTOPAY ? undefined : ins_autopaycampaign,
      state: policyMetaData.state,
      ins_policy,
    });
    setIsTagging(false);
  }, []);

  useEffect(() => {
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });

    return () => {
      window.removeEventListener('pageshow', () => {});
    };
  }, []);

  const enrollForAutoPayOnly = (enrollAutoPay: boolean) => {
    if (autoPayFeatureIsOffline) {
      return navigate(Pages.SorryPage, { state: { errorType: ErrorType.TEMPORARILY_UNAVAILABLE_ERROR } });
    }
    setAutoPayEnroll(enrollAutoPay);
    submitManifest(enrollAutoPay);
  };

  const onEnrollAutoPay = () => {
    enrollForAutoPayOnly(true);
  };

  const onSkipAutoPay = () => {
    enrollForAutoPayOnly(false);
  };

  const onCancel = () => {
    loginOnClick(clubCode);
  };

  const submitManifest = async (selectedAutoPay: boolean) => {
    try {
      const autoPay = !!allowAutoPay && selectedAutoPay;
      let initializePaymentRequest: IInitializePaymentRequest = {
        appFlow: appFlow!,
        amountPaid: amountChosen || 0,
        policyNumber,
        clubCode,
        clubTag,
        autoPay: allowAutoPay ? autoPay : undefined,
        allowAutoPay: !!allowAutoPay,
        brokerRegion,
      };

      setLoading(true);
      const { manifestId } = await sources.initializePayment(initializePaymentRequest);
      let url = `https://${window.location.hostname}/payments/${manifestId}`;

      if (isMobileApp) {
        url += '?mobileapp=true';
      }
      window.location.assign(url);
    } catch (e: any) {
      navigate(Pages.SorryPage, {
        state: { errorTag: UtagHelper.Errors.paymentError, errorType: ErrorType.SYSTEM_ERROR },
      });
    }
  };

  if (tagging) {
    return <></>;
  }

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      {!isMobileApp && <AppHeaderBackButton id="back-button" onClick={onClickBack} />}
      <AutoPayForm
        onEnrollAutoPay={onEnrollAutoPay}
        onSkipAutoPay={onSkipAutoPay}
        onCancel={onCancel}
        minimumDue={minimumDue}
        fullBalance={fullBalance}
        alreadyPaidOption={alreadyPaidOption}
        allowAutoPay={allowAutoPay}
        appFlow={appFlow!}
      />
    </>
  );
};
